// The quiet-indicator derivation shared by both arms (sdk ADR-012).
import { blocksUI, degradedReasonOf, holdsIdentity, type HolderPhase } from '@localagent/sdk';

export type PhaseIndicatorKind = 'activating' | 'renewing' | 'reconnecting';

export interface PhaseIndicator {
  kind: PhaseIndicatorKind;
  text: string;
}

export function phaseIndicator(phase: HolderPhase): PhaseIndicator | null {
  if (blocksUI(phase)) {
    throw new Error(
      `phaseIndicator: ${phase.phase} takes the viewport, so it has no quiet indicator — ` +
        'the caller must branch on blocksUI first',
    );
  }
  const reason = degradedReasonOf(phase);
  if (reason !== null) {
    return reason === 'unconfirmed'
      ? { kind: 'reconnecting', text: 'Reconnecting…' }
      : { kind: 'renewing', text: 'Renewing your session…' };
  }
  if (!holdsIdentity(phase)) {
    return { kind: 'activating', text: 'Activating session…' };
  }
  return null;
}
